// P3 single ascension callout at the bottom of the paid report.
// Phase 4.5B: dual-CTA — primary "View next steps" → /audit/next-steps/:sid
// (Ascension page), secondary "Request implementation" preserved as the
// existing fallback path into the (byte-identical) ImplementationModal.
// Copy of the body paragraph + Next-step eyebrow remain unchanged.
export default function ReportFinalCTA({ onViewNextSteps, onRequestImplementation }) {
  return (
    <div className="sf-card" style={{ borderColor: "var(--sf-gold-dim)" }} data-testid="paid-report-final-cta">
      <div className="sf-eyebrow" style={{ marginBottom: 12 }}>Next step</div>
      <h3 className="sf-display" style={{ fontSize: 22, marginBottom: 14 }}>
        When you're ready, we can help build it.
      </h3>
      <p className="sf-muted-text" style={{ marginBottom: 22, lineHeight: 1.7 }}>
        You now have the diagnosis, the prioritized fixes, and the 90-day
        plan. If you want a SystemForge team to implement it with you, the
        request below routes directly to the founder. It is a conversation,
        not an automatic contract — we review every request before any work
        starts or any cost is committed.
      </p>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button type="button" className="sf-btn" onClick={onViewNextSteps} data-testid="paid-report-next-steps-cta">
          View next steps
        </button>
        <button type="button" className="sf-btn-secondary" onClick={onRequestImplementation} data-testid="paid-report-impl-cta-bottom">
          Request implementation
        </button>
      </div>
    </div>
  );
}
